//====================================================
//    VARIABLES
//====================================================
var reviewContaier = $("#reviewContaier");
var totalReviews = $("#totalReviews");
var count = 1;


//=============================================
//    CREATE STARS
//=============================================
$.fn.stars = function (returnVal) {
  return $(this).each(function () {
    var val = parseFloat($(this).data('value'));
    var size = Math.max(0, (Math.min(5, val))) * 16;
    var span = $('<span />').width(size);
    $(this).html(span);
  });
}

function setStars() {
    return $('.stars').each(function () {
        var val = parseFloat($(this).data('value'));
        var size = Math.max(0, (Math.min(5, val))) * 16;
        var span = $('<span />').width(size);
        $(this).html(span);
    });
}
$('.stars').stars();

//====================================================
//    ADDING NEW_REVIEW BLOCK WHEN CLICK ON SHOW MORE
//====================================================
$("#show-more").on('click', function () {
  var reviewAPI = $("#show-more").data("review-api") + count;

  $.ajax({
    url: reviewAPI,
    dataType: 'JSON',
    method: 'GET',
    data: 'data',
    traditional: false,
    success: function (response) {
      for (var i in response.data) {
        var customerLN = "";
        if (response.data[i].customerLastName != "" && response.data[i].customerLastName != null) {
          customerLN = response.data[i].customerLastName.substring(0, 1) + ".";
        }
        if (response.data[i].source == "FTP") {
          var ftp_reviewBlock = "<div class='px-3 review-block'><p class='m-0'><span class='stars' data-value='" + response.data[i].reviewRate + "'></span></p>" +
            "<p class='my-0'><span data-attr-name='reviewRate'> " + response.data[i].reviewRate + " </span> Survey completed on <span data-attr-name='reviewCompleteDateTime'> " + response.data[i].reviewCompletedDateTime + " </span></p>" +
            "<p class='my-0'>Review By <span data-attr-name='customerFirstName'>" + response.data[i].customerFirstName + "</span><span data-attr-name='customerLastName'> " + customerLN + " </span> for <span data-attr-name='serviceProviderName'> " + response.data[i].serviceProviderName + " </span></p>" +
            "<p class='my-0'><span data-attr-name='transactionDateTime'>Completed transaction in " + response.data[i].transactionDateTime + " </span></p>" +
            "<p><span data-attr-name='description'> " + response.data[i].description + " </span></p></div>";
          reviewContaier.append(ftp_reviewBlock);
        } else {
          var zillow_reviewBlock = "<div class='px-3 review-block'><p class='m-0'><span class='stars green' data-value='" + response.data[i].reviewRate + "'></span><span class='pull-right zillow-logo'></span></p>" +
            "<p class='my-0'><span data-attr-name='reviewRate'> " + response.data[i].reviewRate + " </span> Survey completed on <span data-attr-name='reviewCompleteDateTime'> " + response.data[i].reviewCompletedDateTime + " </span></p>" +
            "<p class='my-0'>Review By <span data-attr-name='customerFirstName'>" + response.data[i].customerFirstName + "</span><span data-attr-name='customerLastName'> " + customerLN + " </span> for <span data-attr-name='serviceProviderName'> " + response.data[i].serviceProviderName + " </span></p>" +
            "<p class='my-0'><span data-attr-name='transactionDateTime'>Completed transaction in " + response.data[i].transactionDateTime + " </span></p>" +
            "<p><span data-attr-name='description'> " + response.data[i].description + " </span></p></div>";
          reviewContaier.append(zillow_reviewBlock);
        }
      }
      count = count + 1;
      if (response.loadMore == false) {
        $("#show-more").remove();
      }
      $('.stars').stars();
    }
  }) // END AJAX CALL
});


//====================================================
//    CLICK REVIEW LOAD
//====================================================
$(document).on("click", ".review-load-more", function () {
    load_reviews();
});
$(document).on("click", ".review-load-more2", function () {
    load_reviews2();
});
function load_reviews() {
  //reviewScroll = false;
  var reviewAPI = $('#reviewContaier').data('review-api') + count;
  $.ajax({
    url: reviewAPI,
    dataType: 'JSON',
    method: 'GET',
    data: 'data',
    traditional: false,
    success: function (response) {
      if (response.data[0] == null) {
        $(".review-load-more")[0].classList.add("d-none");
        return;
      }
      for (var i in response.data) {
        var customerLN = "";
        if (response.data[i].customerLastName != "" && response.data[i].customerLastName != null) {
          customerLN = response.data[i].customerLastName.substring(0, 1) + ".";
        }
        if (response.data[i].source.toLowerCase() != "zillow") {
          var ftp_reviewBlock = "<li class='px-3 review-block' tabindex='0'><p class='m-0'><span class='stars' data-value='" + response.data[i].reviewRate + "'></span></p>" +
            "<p class='my-0'><span data-attr-name='reviewRate'> " + response.data[i].reviewRate + " </span> Survey completed on <span data-attr-name='reviewCompleteDateTime'> " + response.data[i].reviewCompletedDateTime + " </span></p>" +
            "<p class='my-0'>Review By <span data-attr-name='customerFirstName'>" + response.data[i].customerFirstName + "</span><span data-attr-name='customerLastName'> " + customerLN + " </span> for <span data-attr-name='serviceProviderName'> " + response.data[i].serviceProviderName + " </span></p>" +
            "<p class='my-0'><span data-attr-name='transactionDateTime'>Completed transaction in " + response.data[i].transactionDateTime + " </span></p>" +
            "<p><span data-attr-name='description'> " + response.data[i].description + " </span></p></li>";
          reviewContaier.append(ftp_reviewBlock);
        } else {
          var zillow_reviewBlock = "<li class='px-3 review-block'tabindex='0'><p class='m-0'><span class='stars green' data-value='" + response.data[i].reviewRate + "'></span><span class='pull-right zillow-logo'></span></p>" +
            "<p class='my-0'><span data-attr-name='reviewRate'> " + response.data[i].reviewRate + " </span> Survey completed on <span data-attr-name='reviewCompleteDateTime'> " + response.data[i].reviewCompletedDateTime + " </span></p>" +
            "<p class='my-0'>Review By <span data-attr-name='customerFirstName'>" + response.data[i].customerFirstName + "</span><span data-attr-name='customerLastName'> " + customerLN + " </span> for <span data-attr-name='serviceProviderName'> " + response.data[i].serviceProviderName + " </span></p>" +
            "<p class='my-0'><span data-attr-name='transactionDateTime'>Completed transaction in " + response.data[i].transactionDateTime + " </span></p>" +
            "<p><span data-attr-name='description'> " + response.data[i].description + " </span></p></li>";
          reviewContaier.append(zillow_reviewBlock);
        }
      }
      count = count + 1;
        if (response.loadMore == false) {
            $(".review-load-more").remove();
        }
        setStars();

    }
  });

   
}

function load_reviews2() {
    //reviewScroll = false;
    var reviewAPI = $('#reviewContaier').data('review-api') + count;
    $.ajax({
        url: reviewAPI,
        dataType: 'JSON',
        method: 'GET',
        data: 'data',
        traditional: false,
        success: function (response) {
            if (response.data[0] == null) {
                $(".review-load-more2")[0].classList.add("d-none");
                return;
            }
            for (var i in response.data) {
                var customerLN = "";
                if (response.data[i].customerLastName != "" && response.data[i].customerLastName != null) {
                    customerLN = response.data[i].customerLastName.substring(0, 1) + ".";
                }
                var citystate = "";
                if ((response.data[i].city != "" && response.data[i].city != null) || (response.data[i].state != "" && response.data[i].state != null)) {
                    citystate = "from ";
                    if (response.data[i].city != "" && response.data[i].city != null) {
                        citystate += response.data[i].city;
                        if (response.data[i].state != "" && response.data[i].state != null) {
                            citystate += ", ";
                        }
                    }
                    if (response.data[i].state != "" && response.data[i].state != null) {
                        citystate += response.data[i].state;
                    }
                }
                if (response.data[i].source.toLowerCase() == "zillow") {
                    var zillow_reviewBlock = "<li class='px-3 review-block'tabindex='0' itemscope itemtype='https://schema.org/Review'><p class='m-0 customer-name'><span class='stars green' data-value='" + response.data[i].reviewRate + "' itemprop='reviewRating'></span><span class='pull-right zillow-logo'></span>(" + response.data[i].reviewRate + " stars)</p>" +
                        "<p class='mb-0 customer-name' itemprop='author' itemscope itemtype='https://schema.org/Person'><span itemprop='name'>" + response.data[i].customerFirstName + " " + customerLN + " </span> " + citystate + "</p>" +
                        "<p class='my-0 transaction'><span data-attr-name='transactionDateTime' itemprop='datePublished'>Completed transaction in " + response.data[i].reviewCompletedDateTime + " </span></p>" +
                        "<p class='mt-2 customer-review'><span data-attr-name='description' itemprop='reviewBody'> " + response.data[i].description + " </span></p></li>";
                    reviewContaier.append(zillow_reviewBlock);
                }
                else if (response.data[i].source.toLowerCase() == "google") {
                    var google_reviewBlock = "<li class='px-3 review-block mt-8' tabindex='0' itemprop='review' itemscope itemtype='https://schema.org/Review'><p class='m-0 customer-name'><span class='stars' data-value='" + response.data[i].reviewRate + "' itemprop='reviewRating'></span><span class='pull-right google-logo'></span>(" + response.data[i].reviewRate + " stars)</p>" +
                        "<p class='mb-0 customer-name' itemprop='author' itemscope itemtype='https://schema.org/Person'><span itemprop='name'>" + response.data[i].customerFirstName + " " + customerLN + " </span> " + citystate + "</p>" +
                        "<p class='my-0 transaction'><span data-attr-name='transactionDateTime' itemprop='datePublished'>Completed transaction in " + response.data[i].reviewCompletedDateTime + " </span></p>" +
                        "<p class='mt-2 customer-review'><span data-attr-name='description' itemprop='reviewBody'> " + response.data[i].description + " </span></p></li>";
                    reviewContaier.append(google_reviewBlock);
                }
                else {
                    var ftp_reviewBlock = "<li class='px-3 review-block mt-8' tabindex='0' itemprop='review' itemscope itemtype='https://schema.org/Review'><p class='m-0 customer-name'><span class='stars' data-value='" + response.data[i].reviewRate + "' itemprop='reviewRating'></span><span class='pull-right experience-logo'></span>(" + response.data[i].reviewRate + " stars)</p>" +
                        "<p class='mb-0 customer-name' itemprop='author' itemscope itemtype='https://schema.org/Person'><span itemprop='name'>" + response.data[i].customerFirstName + " " + customerLN + " </span> " + citystate + "</p>" +
                        "<p class='my-0 transaction'><span data-attr-name='transactionDateTime' itemprop='datePublished'>Completed transaction in " + response.data[i].reviewCompletedDateTime + " </span></p>" +
                        "<p class='mt-2 customer-review'><span data-attr-name='description' itemprop='reviewBody'> " + response.data[i].description + " </span></p></li>";
                    reviewContaier.append(ftp_reviewBlock);
                }
            }
            count = count + 1;
            if (response.loadMore == false) {
                $(".review-load-more2").remove();
            }
            setStars();

        }
    });


}



